import axios from "../../axiosInstance";
import type { IconLibraryItem } from "@/modules/learningCenter/features/BadgeManagement/types/badge.types";

export const fetchIconLibrary = async (category?: string): Promise<IconLibraryItem[]> => {
  const params = category ? `?category=${encodeURIComponent(category)}` : "";
  const response = await axios.get<{ icons: IconLibraryItem[] }>(`/api/badges/icon-library${params}`);
  return response.data.icons;
};

export default fetchIconLibrary;
